module.exports = __webpack_public_path__ + "img/move_i_know_this.621439c4.png";